


















import { IEntity } from '@/typings/import';
import { Component, Prop, Vue } from "vue-property-decorator";
import { EEntityImportState, EEntityMatchType } from './enums';
import { IImportsTableHeader } from './ImportsTable.vue';
import ImportsTableCell from '@/components/Importer/ImportsTableCell.vue';

@Component({
  components: {
    ImportsTableCell,
  },
})
export default class PropertyUpdateRow extends Vue {
  entityMatchType = EEntityMatchType;

  @Prop({ required: true }) private entity: IEntity<any>;
  @Prop({ required: true }) private headers: IImportsTableHeader[];

  get headerValues() {
    return this.headers.map(h => h.value);
  }
  get shownPropertyUpdates() {
    return this.headerValues.map(hv => this.entity.propertyUpdates.find(pu => pu.propertyName === hv))
    .filter(x => x);
  }

  get rowImportStateClass() {
    switch (this.entity.importState) {
      case EEntityImportState.Unknown:
      case EEntityImportState.Mapped:
        return '';
      case EEntityImportState.Imported:
        return 'color: green lighten-4';
      case EEntityImportState.Failed:
        return 'color: red lighten-4';
      default:
        return '';
    }
  }

  get matchedByClass() {
    switch (this.entity.matchedBy) {
      case EEntityMatchType.Created:
        return 'accent';
      case EEntityMatchType.ExternalId:
      case EEntityMatchType.Ssn:
      case EEntityMatchType.Name:
        return 'primary';
      default:
        return 'red';
    }
  }

  selectRow() {
    this.$emit('selectRow', this.entity);
  }

  selectItem() {
    this.entity.selected = !this.entity.selected;
  }

}
